var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.shouldShowTimeoutWarning)?_c('div',{attrs:{"id":"modal-overlay"}},[_c('div',{attrs:{"id":"modal-panel"}},[_c('p',[_vm._v(_vm._s(_vm.$t('common.sessionTimeout.message')))]),_c('button',{attrs:{"id":"reload-button"},on:{"click":_vm.stayLoggedIn}},[_vm._v(_vm._s(_vm.$t('common.sessionTimeout.stayLoggedIn'))+" ")])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }